import React from 'react';
import { Link, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Breadcrumb, Icon, Row } from 'antd';
import Example from './example/Example';
import Layouts from './layouts/Layouts';
import PanelLayout from '../../../components/panels/PanelLayout';
import HeaderSection from '../../../components/section/SectionHeader';
import ViaRoute from '../../../components/routes/ViaRoute';
import routeLocations from '../../../utility/route-locations';
import LocaleSelector from '../../../components/translations/LocaleSelector';
import './Developer.css';
import DeveloperDiagramPage from './diagram/DeveloperDiagramPage';
import { asViaUrl } from '../../../utility/via-fetch';

function DeveloperPage() {
  return (
    <section className="developer-page">
      <Row type="flex" justify="space-between" align="middle">
        <Breadcrumb separator=">" itemRender="">
          <Breadcrumb.Item>
            <Link className="app-standard-link" to={routeLocations.dashboard}><Icon type="home" /></Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item><FormattedMessage id="developer.short" /></Breadcrumb.Item>
        </Breadcrumb>
        <LocaleSelector />
      </Row>

      <PanelLayout titleId="developer" titleLevel={2}>
        <HeaderSection titleId="sections" />
        <Row>
          <Link to={routeLocations.developer_example}><FormattedMessage id="example" /></Link>
          <br />
          <Link to={routeLocations.developer_layouts}><FormattedMessage id="layouts" /></Link>
          <br />
          <Link to={routeLocations.developer_diagram}><FormattedMessage id="diagram" /></Link>
          <br />
          <Link to={routeLocations.developer_crash}>
            Developer:
            <span role="img" aria-label="rocket-ship">🚀</span>
            Client Error Test
            <span role="img" aria-label="rocket-ship">🚀</span>
          </Link>
          <br />
          <HeaderSection titleId="documentation" />
          <a target="NONE" href={asViaUrl('/rest-documentation/index.html')}>REST Documentation - Enunciate</a>
          <br />
          <a target="NONE" href="http://192.168.60.220/wiki/index.php/Main_Page">Wiki</a>
        </Row>
      </PanelLayout>
    </section>
  );
}

function Developer() {
  return (
    <Switch>
      <ViaRoute titleKey="example" path={routeLocations.developer_example} component={Example} />
      <ViaRoute titleKey="layouts" path={routeLocations.developer_layouts} component={Layouts} />
      <ViaRoute titleKey="diagram" path={routeLocations.developer_diagram} component={DeveloperDiagramPage} />
      <ViaRoute titleKey="developer" path={routeLocations.developer_crash} component={() => { throw new Error('Test Error'); }} />
      <ViaRoute titleKey="developer" path={routeLocations.developer} component={DeveloperPage} />
    </Switch>
  );
}

export default Developer;
